import axios from 'api/axios'

/**
 * A helper class for Invoice
 */
export class InvoiceHelper {
  static #status = {
    '00': 'Pendiente',
    10: 'Invalidada',
    11: 'Validación no disponible',
    12: 'En proceso de validación',
    20: 'Validada',
    30: 'En espera',
    33: 'Pendiente de BackOffice',
    70: 'Aplicada parcial',
    71: 'Aplicada a factura',
    80: 'Error integración',
    90: 'Integrada',
  }

  /**
   * @static
   * @param {string} key
   * @returns {string} returning status
   */
  static getStatus(key) {
    return InvoiceHelper.#status[key]
  }

  /**
   * @static
   * @param {string} code
   * @param {Array<{codigo: string, descripcion: string}>} gruposBalance
   * @returns {string}
   */
  static getGrupoBalanceLabel(code, gruposBalance) {
    if (!code || !gruposBalance) return code
    const grupo = gruposBalance.find((g) => g.codigo === code)
    return grupo ? grupo.descripcion : code
  }

  /**
   * @static
   * @param {string} code
   * @param {Array<{codigo_org_compras: string, nombre: string}>} organizaciones
   * @returns {string}
   */
  static getOrganizacionLabel(code, organizaciones) {
    if (!code || !organizaciones) return code
    const org = organizaciones.find((o) => o.codigo_org_compras === code)
    return org ? org.nombre : code
  }

  /**
   * @typedef Ficheros
   * @type {Object}
   * @property {string} contenido_fichero // bile content in base64
   * @property {string} nombre_fichero // file name
   * @property {string} tipo_fichero // file mimetype
   */

  /**
   * @typedef CreateInvoice
   * @type {Object}
   * @property {Array<Ficheros>} ficheros
   * @property {string} idioma
   * @property {string} numero_remision
   * @property {string} organizacion_compras
   */

  /**
   * @static
   * @async
   * @param {CreateInvoice} invoicePayload
   */
  static async createInvoice({
    ficheros,
    idioma = '01',
    numero_remision = '',
    organizacion_compras = '',
    grupo_balance = '',
  }) {
    const payload = {
      ficheros,
      idioma,
      numero_remision,
      organizacion_compras,
      grupo_balance,
    }
    try {
      const { data } = await axios.post(`/efactura/compras/`, payload)
      return data
    } catch (error) {
      throw new Error(`${error.message}`)
    }
  }
}
